import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import { hasRole, isLoggedIn } from 'src/libs/browser'
import { URL_TEMPLATE, USER_ROLES_ENUM } from 'src/libs/constant'

const Index = () => {
  const router = useRouter()

  useEffect(() => {
    if (isLoggedIn()) {
      if (hasRole([USER_ROLES_ENUM.EMPLOYEE_TEACHER])) {
        router.push(URL_TEMPLATE.SESSION_TEACHING_SCHEDULE)
      } else {
        router.push(URL_TEMPLATE.SYSTEM_DASHBOARD)
      }
    } else {
      router.push(URL_TEMPLATE.SYSTEM_LOGIN)
    }
  })

  return <></>
}

export default Index
